<template>

  <v-content class="ma-0 pa-0 pb-5">
        <v-card>
       <v-alert
       dense
        border="left"
      color="red lighten-5"
      
    >
    <a href="https://www.google.com/intl/es/chrome/?brand=UUXU&gclid=EAIaIQobChMItIi_tJnu9gIVGwytBh1y9AwREAAYASAAEgKbCPD_BwE&gclsrc=aw.ds" target="_blank">
       <img style="padding-top: 3px" width="25px" height="25px" src="../public/chrome.png" alt="Italian Trulli">
    </a>
    Para una mejor experiencia de uso en este portal, se recomienda el navegador google chrome.
       <a href="https://www.google.com/intl/es/chrome/?brand=UUXU&gclid=EAIaIQobChMItIi_tJnu9gIVGwytBh1y9AwREAAYASAAEgKbCPD_BwE&gclsrc=aw.ds" target="_blank">
       (Descargar)
    </a>
    </v-alert>
      
    </v-card>

        <v-card>
          
    <div  class="row"  style="background-color: #fff !important; color: #000 !important;">
      <div  class="col-sm-6">
        <a href="http://www.ugto.mx">
          <img
            style="display: block; margin-left: auto; margin-right: auto;"
            width="236px"
            height="92px"
            alt="Escudo Universidad de Guanajuato"
            src="@/assets/escudo-h.png"
          />
        </a>
      
      </div>
            <div  class="col-sm-6">
        <a href="http://www.ugto.mx">
          <img
            style="display: block; margin-left: auto; margin-right: auto;"
            width="193px"
            height="90px"
            alt="Escudo Universidad de Guanajuato"
            src="@/assets/logo-transparencia.png"
          />
        </a>
        
      </div>
    </div>

    <v-bottom-navigation    grow color="primary" horizontal>
      <v-btn href="https://www.transparencia.ugto.mx">
        <span  style="text-align: center; font-size:130%;color:black;font-weight:bold">INICIO</span>
      </v-btn>
      <v-btn href="https://www.transparencia.ugto.mx/reglamentos">
        <span  style="text-align: center; font-size:130%;color:black;font-weight:bold">REGLAMENTOS</span>
      </v-btn>
      <v-btn href="https://www.transparencia.ugto.mx/normatividad">
        <span  style="text-align: center; font-size:130%;color:black;font-weight:bold">NORMATIVIDAD</span>
      </v-btn>
      <v-btn href="https://www.transparencia.ugto.mx/capacitacion">
        <span  style="text-align: center; font-size:130%;color:black;font-weight:bold">CAPACITACIÓN</span>
      </v-btn>
        <v-btn href="https://www.transparencia.ugto.mx/directorio">
        <span  style="text-align: center; font-size:130%;color:black;font-weight:bold">DIRECTORIO</span>
      </v-btn>
      <v-btn href="https://www.transparencia.ugto.mx/avisos-de-privacidad">
        <span  style=" text-align: center; font-size:130%;color:black;font-weight:bold">AVISOS DE<br> <p style="  text-align: center; font-size:70%;color:black;font-weight:bold ">PRIVACIDAD</p></span>
      </v-btn>
      <!--<v-btn
        href="https://www.colmena.ugto.mx/Transparencia/"
        onclick="javascript:window.open(this.href); return false;"
      >
        <span  style="font-size:130%;color:black;font-weight:bold">INICIAR SESION</span>
      </v-btn>-->
     <v-btn
        href="https://intranet3.ugto.mx/Transparencia/"
        onclick="javascript:window.open(this.href); return false;"
      >
        <span  style="font-size:130%;color:black;font-weight:bold">INICIAR SESION</span>
      </v-btn>
    </v-bottom-navigation>
    <v-tabs>
      <v-tab>
        <v-icon left>mdi-account</v-icon>Obligaciones de Transparencia
      </v-tab>
      <v-tab>
        <v-icon left>mdi-lock</v-icon>Información Pública de Oficio (Derogada)
      </v-tab>
      <v-tab-item>
        <v-divider></v-divider>

        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Fracciones Comunes</v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- <v-btn
            v-if="oidcUser==null"
            href="https://intranet3.ugto.mx/Transparencia/"
            onclick="javascript:window.open(this.href); return false;"
            light
          >Inicia sesion</v-btn>-->
        </v-toolbar>
        <v-tabs>
          <v-tab>
            <v-icon left>picture_in_picture</v-icon>Clasificador Fracciones
          </v-tab>
          <v-tab>
            <v-icon left>picture_in_picture</v-icon>Clasificador Unidades
          </v-tab>
          <v-tab>
            <v-icon left>list</v-icon>Tabla de Aplicabilidad
          </v-tab>

                 <v-tab-item class="px-5">

                <v-row class="mt-5" align="center" justify="end">
                    <v-col cols="12" lg="4">
                        <v-text-field solo label="Buscar" v-model="titlef"></v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col sm="12" md="6" lg="3" text-sm-right v-for="(item, i) in searchFiltroF" :key="i">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-card height="75px" v-on="on" class="pb-3" style="margin-bottom:40px; text-align: left!important" @click="modalitem(item)">
                                    <v-btn dark elevation="8" style="margin-top:-20px; margin-left:15px " :color="item.color" height="60px" width="60px">
                                        <v-icon x-large >
                                            {{item.nombre}}
                                        </v-icon>
                                    </v-btn>
                                    <h4 style="margin-left:95px; margin-right:10px; margin-top:-25px  " class="block-ellipsis text--secondary">
                                        {{item.descripcionCorta}}
                                    </h4>
                                </v-card>
                            </template>
                            <span>{{item.fraccion}}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-toolbar flat color="primary" dark>
                    <v-toolbar-title class="ml-3">Específicas</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row class="mt-10">
                    <v-col sm="12" md="6" lg="3" text-sm-right v-for="(item, i) in searchFiltroFEspec" :key="i">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-card height="75px" v-on="on" class="pb-3" style="margin-bottom:40px;  text-align: left!important" @click="modalitem(item)">
                                    <v-btn dark elevation="8" style="margin-top:-20px; margin-left:15px " :color="item.color" height="60px" width="60px">
                                        <v-icon x-large>
                                            {{item.nombre}}
                                        </v-icon>
                                    </v-btn>
                                    <h4 style="margin-left:95px; margin-right:10px; margin-top:-25px " class="block-ellipsis text--secondary">
                                        {{item.descripcionCorta}}
                                    </h4>
                                </v-card>
                            </template>
                            <span>{{item.fraccion}}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-tab-item>

          <v-tab-item class="px-5">
          <v-row class="mt-5" align="center" justify="end">
            <v-col cols="12" lg="4">
              <v-text-field solo label="Buscar" v-model="title"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12" md="6" lg="3" text-sm-right v-for="(item, i) in searchFiltro" :key="i">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-card
                    height="75px"
                    v-on="on"
                    class="pb-3"
                    style="margin-bottom:40px;  text-align: left!important"
                    @click="modalitemUnidad(item)"
                  >
                    <v-btn
                      dark
                      elevation="8"
                      style="margin-top:-20px; margin-left:15px "
                      :color="item.color"
                      height="60px"
                      width="60px"
                    >
                      <v-icon x-large>{{item.icono}}</v-icon>
                    </v-btn>
                    <h4
                      style="margin-left:95px; margin-right:10px; margin-top:-25px"
                      class="block-ellipsis text--secondary"
                    >{{item.nombreUnidad}}</h4>
                  </v-card>
                </template>
                <span>{{item.nombreUnidad}}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-tab-item>

          <v-tab-item>
            <v-card>
              <v-card-title>
                   <v-btn  color="primary"    @click="descTblAplicabilidad"  >Descargar Tabla de Aplicabilidad</v-btn>
        
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="desserts"
                sort-by="calories"
                class="elevation-1"
                :search="search"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Fracciones</v-toolbar-title>
                    <v-divider class="mx-3" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
                <template v-slot:item.aplica="{ item }">
                  <v-btn
                    depressed
                    small
                    :color="getColor(item.aplica)"
                    dark
                    @click="modalaplica(item)"
                  >{{gettxt(item.aplica)}}</v-btn>
                </template>
                <template v-slot:item.action="{ item }">
                  <!-- <v-icon small class="mr-2"   @click="dialog = true"> find_in_page</v-icon> -->
                  <v-icon md class="mr-2" @click="modalitem(item)">find_in_page</v-icon>
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="open">Datos no encontrados</v-btn>
                </template>
              </v-data-table>
            </v-card>
            <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
          </v-tab-item>
        </v-tabs>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <table class="table table-hover">
            <tr>
              <td>
                I. Leyes, reglamentos, decretos administrativos, y normas aplicables.
           
                <small>
                  <!--<a
                    href="http://www.ugto.mx/organos-de-gobierno/legislacion-universitaria"
                    target="_blank"
                  >Leyes, reglamentos, decretos administrativos, y normas aplicables.</a> |
                  <a
                    href="http://www.transparencia.ugto.mx/index.php/publico/normatividad"
                    target="_blank"
                  >Normatividad en Materia de Transparencia</a> |
                  <a
                    href="http://www.transparencia.ugto.mx/index.php/publico/reglamentos"
                    target="_blank"
                  >Reglamentos de Acceso a la Información Pública de la Universidad de Guanajuato</a> |-->
                </small>
           

                <small>
                  <!--<a @click="listaRachivo(2)">Ver listado de archivos</a>-->
                </small>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                II. Estructura orgánica.
             
                <small>
                  <!--<a
                    href="http://drh.ugto.mx/index.php/departamento-de-gestion-de-recursos-humanos/manuales-de-organizacion"
                    target="_blank"
                  >Manuales de Organización</a> |-->
                </small>
          

               <small>
                  <!--<a @click="listaRachivo(3)">Ver listado de archivos</a>-->
                </small>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                III. Directorio de servidores públicos.
         
                <small>
                  <!--<a
                    href="http://www.ugto.mx/directorio-universidad-guanajuato"
                    target="_blank"
                  >Directorio de servidores públicos</a> |-->
                </small>
          
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                IV. Tabulador mensual de sueldos y salarios, precisando todo género de percepciones y descuentos.
            

              <small>
                  <!--<a @click="listaRachivo(5)">Ver listado de archivos</a>-->
                </small>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                V. El sistema de premios, estímulos y recompensas.
            

               <small>
                 <!-- <a @click="listaRachivo(6)">Ver listado de archivos</a>-->
                </small>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                <p>
                VI. Gastos de representación, costo de viajes, viáticos y otro tipo de gastos realizados por los servidores públicos en ejercicio o con motivo de sus funciones.
                <br>              

                 <small>
                  <a @click="listaRachivo(7)">Ver listado de archivos</a>
                </small>
                </p>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                VII. Domicilio, número telefónico y dirección electrónica de la Unidad de Acceso.
          
                <small>
                 <!-- <a
                    href="http://www.transparencia.ugto.mx/index.php/publico/contacto"
                    target="_blank"
                  >Domicilio, número telefónico y dirección electrónica de la Unidad de Acceso.</a> |-->
                </small>
              
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                VIII. Indicadores de la gestión, las metas y objetivos de sus programas y el informe del ejercicio de los recursos públicos asignados o asociados a ellos.
          

              <small>
                  <!--<a @click="listaRachivo(9)">Ver listado de archivos</a>-->
                </small>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                IX. Servicios, trámites, requisitos y formatos y, en su caso el monto de los aranceles para acceder a los mismos.
         
                <small>
                  <!--<a
                    href="http://www.ugto.mx/images/pdf/aranceles/aranceles-universidad-guanajuato-2016.pdf"
                    target="_blank"
                  >Aranceles UG 2016</a> |
                  <a
                    href="http://www.ugto.mx/estudiantes/"
                    target="_blank"
                  >Catálogo de Servicios de la Universidad de Guanajuato - DCE (Alumnos)</a> |
                  <a
                    href="http://www.ugto.mx/"
                    target="_blank"
                  >Catálogo de Servicios de la Universidad de Guanajuato - DCE (Profesores)</a> |-->
                </small>
         

                 <small>
                  <!--<a @click="listaRachivo(10)">Ver listado de archivos</a>-->
                </small>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                X. Cuenta pública, el monto del presupuesto asignado, así como los informes sobre su ejecución y los datos de la deuda pública, así como los documentos en los que consten éstos.
         

                <small>
                  <!--<a @click="listaRachivo(11)">Ver listado de archivos</a>-->
                </small>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                XI. Destinatarios y el uso autorizado de toda entrega de recursos públicos, cualquiera que sea su destino, así como los informes que dichas personas deben entregar sobre el uso y destino de éstos.

                <small>
                 <!-- <a @click="listaRachivo(12)">Ver listado de archivos</a>-->
                </small>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                XII. Enajenaciones de bienes que realicen por cualquier título o acto, indicando los motivos, beneficiarios o adquirientes y los montos de las operaciones.
      

                <small>
                  <!--<a @click="listaRachivo(13)">Ver listado de archivos</a>-->
                </small>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                XIII. Montos asignados y criterios de acceso a los programas de subsidio. N/A
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                XIV. Resultados finales de las auditorias.
           
                <small>
                  <!--<a
                    href="http://contraloria.ugto.mx/auditorias.html"
                    target="_blank"
                  >Resultados finales de las auditorias.</a> |-->
                </small>
       
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                XV. Reglas para otorgar concesiones, licencias, permisos o autorizaciones; su objeto y vigencia; así como los nombres de los titulares o beneficiarios. N/A
                <br />
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                XVI. Padrón inmobiliario y mobiliario.
                <br />

                 <small>
                  <!--<a @click="listaRachivo(17)">Ver listado de archivos</a>-->
                </small>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                XVII. Listado de las convocatorias a concursos, subastas, licitaciones y sus resultados así como de los contratos, su monto y a quienes les fueron asignados, y en su caso, los participantes.
                <br />

                <small>
                  <!--<a @click="listaRachivo(18)">Ver listado de archivos</a>-->
                </small>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                XVIII. Informes que por disposición legal se generen y las actas o minutas de sesiones públicas de cuerpos colegiados.
      
                <small>
                  <!--<a
                    href="http://www.ugto.mx/organos-de-gobierno/consejo-general-universitario"
                    target="_blank"
                  >Acuerdos del Consejo General Universitario</a> |
                  <a
                    href="http://www.ugto.mx/organos-de-gobierno/consejos-universitarios-de-campus"
                    target="_blank"
                  >Acuerdos de los Consejos Universitarios de Campus</a> |
                  <a
                    href="http://www.comunicacion.ugto.mx/informes/2004-2005/memorias/inicial.htm"
                    target="_blank"
                  >Informe Anual de Actividades 2004-2005</a> |
                  <a
                    href="http://www.comunicacion.ugto.mx/informes/2005-2006/memorias/inicial.htm"
                    target="_blank"
                  >Informe Anual de Actividades 2005-2006</a> |
                  <a
                    href="http://www.comunicacion.ugto.mx/informes/2006-2007/memorias/inicial.htm"
                    target="_blank"
                  >Informe Anual de Actividades 2006-2007</a> |
                  <a
                    href="http://www.comunicacion.ugto.mx/informes/2007-2008/contenido/index.html"
                    target="_blank"
                  >Informe Anual de Actividades 2007-2008</a> |
                  <a
                    href="http://www.comunicacion.ugto.mx/informes/2010-2011/index.html"
                    target="_blank"
                  >Informe Anual de Actividades 2010-2011</a> |
                  <a
                    href="http://www.comunicacion.ugto.mx/informes/2011-2012/"
                    target="_blank"
                  >Informe Anual de Actividades 2011-2012</a> |
                  <a
                    href="http://www.comunicacion.ugto.mx/informes/2012-2013/"
                    target="_blank"
                  >Informe Anual de Actividades 2012-2013</a> |
                  <a
                    href="http://www.comunicacion.ugto.mx/informes/2013-2014/"
                    target="_blank"
                  >Informe Anual de Actividades 2013-2014</a> |
                  <a
                    href="http://www.comunicacion.ugto.mx/informes/2014-2015/"
                    target="_blank"
                  >Informe Anual de Actividades 2014-2015</a> |
                  <a
                    href="http://www.ugto.mx/informe2015-2016/"
                    target="_blank"
                  >Informe Anual de Actividades 2015-2016</a> |-->
                </small>
               

                 <small>
                  <!--<a @click="listaRachivo(19)">Ver listado de archivos</a>-->
                </small>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                XIX. Documentos en que consten las cuentas públicas, empréstitos y deudas contraídas. (NO APLICA para empréstitos y deudas contraídas)

                <small>
                  <!--<a @click="listaRachivo(20)">Ver listado de archivos</a>-->
                </small>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                XX. La relación de solicitudes de acceso a la información pública, así como las respuestas.
                <small>
                 <!-- <a
                    href="http://www.transparencia.ugto.mx/index.php/solicitudes/resultados?mis_solicitudes%20=%20%27%27"
                    target="_blank"
                  >Relación de solicitudes de acceso a la información pública, así como las respuestas.</a> |-->
                </small>

               <small>
                 <!-- <a @click="listaRachivo(21)">Ver listado de archivos</a>-->
                </small>
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                XXI. Resoluciones de los órganos jurisdiccionales locales. N/A
                <br />
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </v-card>
      </v-tab-item>
    </v-tabs>

  <v-row
      justify="center"
    >
      <v-dialog
        v-model="dialogFraccionUnidad"
          max-width="1100"
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            
            <v-btn icon dark @click="dialogFraccionUnidad = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ UnidadSEleccionada }}</v-toolbar-title>

            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card>
            <v-data-table
              :headers="fnheaders"
              :items="dessertsPunidad"
              sort-by="calories"
              class="elevation-1"
            >
              <template v-slot:top></template>
              <template v-slot:item.action="{ item }">
                <v-icon md class="mr-2" @click="modalitem(item)">find_in_page</v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary">Datos no encontrados</v-btn>
              </template>
            </v-data-table>
          </v-card>
          <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
        </v-card>
        <v-dialog
          v-model="dialogArcivoUnidad"
          max-width="1100"
        
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="dialogArcivoUnidad = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>{{ SdescripcionCorta }}</v-toolbar-title>

              <v-spacer></v-spacer>
            </v-toolbar>

            <v-divider></v-divider>
            <v-card>
              <v-data-table
                :headers="aheaders"
                :items="adesserts"
                sort-by="calories"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Archivos</v-toolbar-title>
                    <v-divider class="mx-3" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>

                <template v-slot:item.action="{ item }">
                  <v-icon md class="mr-2"   color="teal darken-2" @click="desArchivo(item)">save_alt</v-icon>
                  <!-- <v-icon small class="mr-2"  @click="open"> find_in_page</v-icon> -->
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="modalitem">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
            <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
          </v-card>
        </v-dialog>
      </v-dialog>
 
       <v-dialog
          v-model="dialog"
          max-width="1100"
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>{{ SdescripcionCorta }}</v-toolbar-title>

              <v-spacer></v-spacer>
            </v-toolbar>

            <v-divider></v-divider>
            <v-card>
              <v-data-table
                :headers="aheaders"
                :items="adesserts"
                sort-by="calories"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Archivos</v-toolbar-title>
                    <v-divider class="mx-3" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>

                <template v-slot:item.action="{ item }">
                  <v-icon md class="mr-2"  color="teal darken-2" @click="desArchivo(item)">save_alt</v-icon>
                  <!-- <v-icon small class="mr-2"  @click="open"> find_in_page</v-icon> -->
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="modalitem">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
            <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
          </v-card>
        </v-dialog>


        <v-dialog
          v-model="dialoglstArchivos"
          max-width="1100"
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="dialoglstArchivos = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Archivos Derogados</v-toolbar-title>

              <v-spacer></v-spacer>
            </v-toolbar>

            <v-divider></v-divider>
            <v-card>
              <v-data-table
                :headers="aheadersDerogada"
                :items="dtderogada"
                sort-by="calories"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Archivos</v-toolbar-title>
                    <v-divider class="mx-3" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>

                <template v-slot:item.action="{ item }">
           
                    <v-icon md class="mr-2"  color="teal darken-2" @click="desArchivoDerogada(item)">save_alt</v-icon>             
             
                  <!-- <v-icon small class="mr-2"  @click="open"> find_in_page</v-icon> -->
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="modalitem">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
            <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
          </v-card>
        </v-dialog>
         <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      <v-dialog
        v-model="dialog1"
        max-width="500px"
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>No Aplíca {{ vunidad }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>{{textmodal }}</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="dialog1 = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
         <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
  </v-row>

    <!-- ///////////////////////////////////termina dialog///////////////////////////// -->
    <v-divider></v-divider>
    </v-card>
        <v-divider></v-divider>
        <p></p>




  </v-content>
</template>

<script>
import { axiosSingleton } from "@/plugins/axios";
import  fraccionServices  from "../services/FraccionService";

import PubFracciones from "./PubFracciones.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import axunidad from "axios";
import { async } from "q";

//let url_api = 'https://colmenac.ugto.mx/rg/Transparencia/'
//let url_api = 'https://localhost:44340/'
let url_api = 'https://enjambrec.ugto.mx/RG/Transparencia/'

//validacion del for,ulario

//termina validacionde formulario

// import Ptbls  from '@/components/PubFracciones.vue'

export default {
  components: { PubFracciones },

  props: [],

  data: () => ({
    backgroundColor: "primary",
   UnidadSEleccionada: "",
    SdescripcionCorta: "",
    dialogArcivoUnidad: false,
    Unidadid: 1,
    search: "",
    textmodal: "",
    step: 1,
    dialog: false,
    dialog1: false,
    dialoglstArchivos: false,
    dtderogada: [],
    dialogFraccionUnidad: false,
    list: null,
    title: "",
    titlef: "",
    window: 1,
    name: "",
    email: "",
    icon: "",
    fitems: [],
    select: null,
    details: {
      colors: [] // icons: []
    },
    formClasi: {
      icon: ""
    },

    checkbox: false,
    headers: [
      { text: " # ", value: "numFraccion" },
      { text: "Fraccion", value: "fraccion" },
      { text: "Tipo fraccion", value: "tipoFraccion" },
      { text: "Aplicabilidad", value: "aplica" },
      { text: "Archivos", value: "action", sortable: false }
    ],

    aheaders: [
      { text: "Archivo ", value: "nombreArchivo" },
      { text: "Año", value: "anio" },
      { text: "periodo", value: "periodo" },
      { text: "Descargar", value: "action", sortable: false }
    ],
    aheadersDerogada: [
      { text: "Archivo ", value: "nombre_archivo" },
      { text: "Descargar", value: "action", sortable: false }
    ],
       fnheaders: [
      { text: " # Fraccion", value: "numFraccion" },
      { text: "Fraccion", value: "fraccion" },
      { text: "tipo fraccion", value: "tipoFraccion" },
      { text: "Archivos", value: "action", sortable: false }
    ],


    tblheaders: [
      { text: "Archivo ", value: "nombre_archivo" },
    { text: 'Descargar', value: 'action', sortable: false }
      ],
    edesserts: [],
    desserts: [],
    btndesserts: [],
    adesserts: [],
    editedIndex: -1,
    editedItem: {
      nombreUnidad: "",
      Siglas: 0,
      idUnidad: 0
    },
    defaultItem: {
      nombreUnidad: "",
      Siglas: 0,
      idUnidad: 0,
      idFraccion: 0
    },
    respddl: [],
    items: [],
    aitems: [],
    arid: 0,
    vunidad: "",
      dessertsPunidad: []
  }),

  computed: {
    styleHeader() {
      return {
        backgroundColor: this.formClasi.color,
        color: this.formClasi.forecolor
      };
    },

    ...mapGetters({
      oidcUser: "oidcStore/oidcUser",
      oidcAccessToken: "oidcStore/oidcAccessToken"
    }),

    slotData() {
      return {
        details: this.details
      };
    },

    isReadOnly() {
      return this.readOnly || this.$dayspan.readOnly;
    },

   searchFiltro: function() {
      return this.fitems.filter(item => item.nombreUnidad.toLowerCase().includes(this.title.toLowerCase()));
    },
    
    searchFiltroF: function() {
      return this.btndesserts.filter(item =>
        item.fraccion.toLowerCase().includes(this.titlef.toLowerCase())
      );
    },
    searchFiltroFEspec: function() {
      return this.edesserts.filter(item =>
        item.fraccion.toLowerCase().includes(this.titlef.toLowerCase())
      );
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    let self = this;
    //  this.initialize();
    self.getCatUnidad();
  },

  methods: {
    ...mapActions({
      signOutOidc: "oidc/signOutOidc"
    }),

    getColor(aplica) {
      //  console.log("color aplica", aplica);
      if (aplica > 1) return "red";
      else return "green";
    },

    gettxt(aplica) {
      //  console.log("aplica txt", aplica);
      if (aplica > 1) return "No aplíca";
      else return "Aplíca";
    },

    getCatUnidad() {
      let self = this;
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService.getBtnUnidad().then(r => {
        this.fitems = r.data;
      });
    
      self.tblFraccion();
    },

    tblFraccion() {
      let self = this; 
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService.getCatFraccion().then(r => {
        this.desserts = r.data;
        console.log("desserts", this.desserts);
      });
      self.Fraccionbtn();
    },

    Fraccionbtn() {
      let self = this;
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService.getCatFraccionC().then(r => {
        this.btndesserts = r.data;
        console.log("btndeserts", this.desserts);
      });
      self.Fraccione();
    },
    Fraccione() {
      let self = this;
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService.getCatFraccionE().then(r => {
        this.edesserts = r.data;
        console.log("especifica", this.desserts);
          self.VisitaGeneral();
      });
    },
    VisitaGeneral(){
      let browserName;

    var ua= navigator.userAgent;
    var tem; 
    var M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if(/trident/i.test(M[1])){
        tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
        browserName= 'IE '+(tem[1] || '');
    }
    if(M[1]=== 'Chrome'){
        tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
        if(tem!= null) 
        {
        browserName= tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
    }
    M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
    {
        browserName= M.join(' ');
    }
  

      let self = this; 
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService.visitaGeneral(browserName).then(r => {
              console.log("respuesta", r.data.data);      
      });
    },

    modalaplica(item) {
      console.log("mosalAplica", item);
      this.textmodal = item.descNoaplica;
      console.log("desdemodal 2", this.textmodal);
      this.dialog1 = true;
    },

    //modal derogadas lista
    ///////////////////////////////////////////////////////////

    async listaRachivo(item) {
    
      let self = this;
      const dtderogadab = []; 
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService



        .derogadas(item)
        .then(r => {
          this.adesserts = r.data;
        
        

var array = JSON.parse(this.adesserts);
array.forEach(function(object) {
   dtderogadab.push(object);
    //  var dtderogada = Object.getOwnPropertyDescriptor(object);
  //  dtderogada=object;
  //  console.log( "ESTO",this.dtderogada);
});

 this.dtderogada=dtderogadab;
 this.dialoglstArchivos = true;
console.log("ASIGNADO OI",this.dtderogada);
        });
      // console.log(this.editedItem);
    },


    //termina derogadas  lsiat modal

    modalitem(item) {
      let self = this;
      this.SdescripcionCorta=item.descripcionCorta;
      const index = this.desserts.indexOf(item);
      console.log("modal", item);
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService

        .tblArchivosPubli(item.idFraccion)
        .then(r => {
          this.adesserts = r.data;
          console.log("modalitemsadeserts", this.adesserts);
          self.fnVisitaFraccion(item.idFraccion);
        });

      this.dialog = true;
    },
    fnVisitaFraccion(id_fraccion)
    {
      let self = this;
      let browserName;

      var ua= navigator.userAgent;
      var tem; 
      var M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if(/trident/i.test(M[1])){
        tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
        browserName= 'IE '+(tem[1] || '');
      }
      if(M[1]=== 'Chrome'){
        tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
        if(tem!= null) 
        {
        browserName= tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
      }
      M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
      if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
      {
        browserName= M.join(' ');
      }
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService
        .visitaFraccion(id_fraccion,browserName)
        .then(r => {
     
          console.log("modalitemsadeserts", r.data.data);

        });
    },
   modalitemUnidad(item) {
      let self = this;
      this.UnidadSEleccionada=item.nombreUnidad;
      this.Unidadid=item.idUnidad;
      const index = this.desserts.indexOf(item);
      console.log("modalunidad", item.idUnidad);

      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService
        .getCatFraccionf(item.idUnidad)
        .then(r => {
          this.dessertsPunidad = r.data;
         
          console.log("regreso", this.dessertsPunidad);
        });

      this.dialogFraccionUnidad = true;
    },
    desArchivoDerogada(item) {
      window.open("http://www2.administrativos.ugto.mx/transparencia/uploads/ipo/" + item.nombre_archivo_fisico, '_blank', 'noreferrer');
    },
    desArchivo(item) {
      let self = this;
      const index = this.desserts.indexOf(item);
      console.log("Archico", item);
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService

        .archivodow(item.idArchvio)
        .then(r => {
          this.adesserts = r.data;
          //console.log( "adeserts",this.adesserts);
        });
      console.log(this.editedItem);
      this.dialog = true;
    },


      descTblAplicabilidad(item) {
      let self = this;
      const index = this.desserts.indexOf(item);
      console.log("Archico", item);
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService

        .descTblApli()
        .then(r => {
          // this.adesserts = r.data;
          //console.log( "adeserts",this.adesserts);
        });
      console.log(this.editedItem);
      // this.dialog = true;
    },
        modalitemUnidadArchivo(item) {
      let self = this;
      this.SdescripcionCorta=item.descripcionCorta;
      const index = this.desserts.indexOf(item);
      console.log("modalunidad", item);
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService

        .tblArchivosPunidad(item.idUnidad)
        .then(r => {
          this.adesserts = r.data;
          console.log("modalitemsadeserts", this.adesserts);
        });
 
       this.dialogArcivoUnidad = true;
    },

    submit() {
      this.$v.$touch();
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    }
  }
};
</script>
<style lang="scss" scoped>
.v-tab {
    background-color: gainsboro;
}

.v-tab--active {
    background-color: white;

}

.block-ellipsis {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    margin: 0 auto;
    line-height: 1.4;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.v-btn--floating.v-btn--left {
    margin-left: 0px !important;

    .v-icon {
        height: auto;
    }
}

.ds-calendar-event-popover-card {
    .v-toolbar__extension {
        padding: 0 16px !important;
        height: 60px !important;
        align-items: start;

        .v-toolbar__title {
            width: 100%;
            margin-left: 56px;
            margin-right: 0px;

            .v-input__slot {
                background-color: rgba(255, 255, 255, 0.2) !important;

                input {
                    caret-color: rgba(0, 0, 0, 0.87) !important;
                }
            }
        }
    }
}

.v-text-field--full-width {
    width: 100%;
}

.v-card__text {
    padding: 16px 0;

    .v-list {
        padding-bottom: 0px;

        >div:first-child {
            margin-bottom: 1em;
        }

        .v-list__tile {
            height: auto !important;
        }
    }
}

.ds-create-popover-save {
    background-color: transparent !important;
}

.ds-color-option {
    width: 100%;
    color: white;
    padding: 4px;
}

.v-input {
    margin-bottom: 8px !important;
}
</style>
